@if (loading) {
  <div class="load-indicator-container">
    <p>{{ translation?.loading }}</p>
    <abc-load-indicator></abc-load-indicator>
  </div>
} @else {
  @if (executed && !resultsEmpty) {
    <pre><code #code></code></pre>
  } @else {
    @if (resultsEmpty || !data) {
      <div class="message-container">
        @if (!loading) {
          <p>
            {{ translation?.resultMessage.clickMessage }} '{{ translation?.resultMessage.button }}'
            <span class="dx-icon dx-icon-alignjustify"></span>{{ translation?.resultMessage.viewMessage }}
          </p>
        }
      </div>
    }
  }
}

